import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import '@/icons' // icon
import '@/permission' // permission control

import AudioRecorder from 'vue-audio-recorder'

Vue.use(AudioRecorder)

// 自定义
import permissionStr from '@/directive/permission/index'
import enums from '@/components/api/enumApi'
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */
// import { mockXHR } from '../mock'
// if (process.env.NODE_ENV === 'production') {
//   mockXHR()
// }

import audio from 'vue-mobile-audio'
Vue.use(audio)

// set ElementUI lang to EN
Vue.use(ElementUI, { locale })
Vue.use(permissionStr)

Vue.prototype.common = enums

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
